import parseGithubApiV3Response from './parseGithubApiV3Response'

/**
 * Get the branch head commit
 * @param {string} authToken
 * @param {string} repoOwner
 * @param {string} repoName
 * @param {string} branchName
 * @returns {Promise<object>}
 */
function getHead(authToken, repoOwner, repoName, branchName){
  return fetch(`https://api.github.com/repos/${repoOwner}/${repoName}/git/refs/heads/${branchName}`, {
    headers: {
      'Accept': 'application/vnd.github.v3+json',
      'Authorization': `token ${authToken}`,
    },
  })
  .then(parseGithubApiV3Response)
}

export default getHead


// WEBPACK FOOTER //
// ./src/lib/getHead.js